import React, { useState } from 'react';
import axios from 'axios';
import { Modal, Table, Form, Button, Alert } from 'react-bootstrap';
import '../../App.css';

const ReturnPurchase = ({purchase, onClose, onReturnProcessed}) => {
    const [returnQuantities, setReturnQuantities] = useState(
        purchase.items.map(item => ({
            ...item,
            // returnQuantity: item.quantity,
            returnQuantity: 0, // default return quantity to 0
            // amount: parseFloat(item.purchase_price) * item.quantity,
            amount: 0, // default amount to 0
            error: '', // add error field for individual items
        }))
    );
    const [error, setError] = useState('');

    const handleReturnQuantityChange = (e, index) => {
        const newReturnQuantity = parseInt(e.target.value) || 0;
        setReturnQuantities(prevQuantities => {
            const updatedItems = prevQuantities.map((item, idx) => {
            // the above  underlined error is just a static code analysis tool misinterpreting the code
                if(idx === index) {
                    let error = '';
                    const purchasedQuantity = parseFloat(item.quantity);

                    // frontend validation: check if the return quantity is greater than the purchased quantity
                    if(newReturnQuantity > purchasedQuantity) {
                        error = 'Return quantity cannot be greater than purchased quantity';
                    } else if(newReturnQuantity < 0) {
                        error = 'Return quantity cannot be less than 0';
                    }

                    return {
                        ...item,
                        returnQuantity: newReturnQuantity,
                        amount: parseFloat(item.purchase_price) * newReturnQuantity,
                        error,
                    };
                }
                return item;
            });
            return updatedItems;
        });
    };

    const processReturn = async () => {
        // reset general error state
        setError('');

        // Frontend validation: ensure no item has a validation error
        const hasError = returnQuantities.some(item => item.error);
        if(hasError) {
            setError('Please correct the errors before proceeding');
            return;
        }

        const token = localStorage.getItem('token');
        const returnedItems = returnQuantities
            .filter(item => item.returnQuantity > 0)
            .map(item => ({
            product_id: item.product,
            quantity: item.returnQuantity,
             }));

        if (!purchase || !purchase.id) {
            console.error('Purchase or purchase ID is not defined');
            return;
        }

        const returnData = {
            purchase_id: purchase.id,
            returned_items: returnedItems,
            purchase: purchase.id, //assuming that the purchase id is the ID f the purchase
            return_date: new Date().toISOString().split('T')[0], //current date in YYYY-MM-DD format
        };

        try {
            await axios.post('/api/purchasereturns/', returnData, {
                headers: {Authorization: `Token ${token}`}
            });
            // call the onReturnProcessed callback to update the parent component
            if (onReturnProcessed) {
                await onReturnProcessed();
            }
            onClose(); //close the modal
        } catch(error) {
            console.error('Error processing return:', error);
            // extract error message from response and set error state
            if (error.response && error.response.data) {
                const errorMessage = error.response.data.detail || 'An error occurred while processing the return';
                setError(errorMessage);
            } else {
                setError('An unexpected error occurred')
            }
        }
    };

    return (
        <div>
            {error && <Alert variant="danger">{error}</Alert>}
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>Product</th>
                        <th>Quantity</th>
                        <th>Return Quantity</th>
                        <th>Unit Price</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {returnQuantities.map((item, index) => (
                        <tr key={item.id ? item.id : index}>
                            <td>{item.product_name}</td>
                            <td>{item.quantity}</td>
                            <td>
                                <Form.Control
                                    type="number"
                                    value={item.returnQuantity}
                                    min="0"
                                    max={item.quantity}
                                    step="0.01"
                                    onChange={(e) => handleReturnQuantityChange(e, index)}
                                />
                                {item.error && (
                                    <small className="text-danger">{item.error}</small>
                                )}
                            </td>
                            <td>{parseFloat(item.purchase_price).toFixed(2)}</td>
                            <td>{item.amount.toFixed(2)}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <Modal.Footer>
                <Button variant="primary" onClick={processReturn}>Process Return</Button>
                <Button variant="secondary" onClick={onClose}>Cancel</Button>
            </Modal.Footer>
        </div>
    );
};

export default ReturnPurchase;
